import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Papa from "papaparse";
import {
  binLocationListAction,
  storeIdAction,
} from "../../../redux/actions/general-action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  goodsTempProVeriAction,
  purchaseInvoiceEditAction,
  purchaseInvoiceReceiptCreateAction,
} from "../../../redux/actions/purchase-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import PurchaseBatchesPanel from "../purchase-batches-panel";
import BulkGrnModal from "../modals/bulk-grn-modal";
import GrnCsvImport from "../goods-receipt/grn-csv-import";
import SalesPurchaseFooter from "../../sales-section/sales-purchase-footer";
import PurchaseItemsSection from "../purchase-items-section";
import SalesPurchaseNavbar from "../../sales-section/sales-purchase-navbar";
import PurchaseCreditNotePanel from "../goods-receipt/purchase-cr-db-notes-panel";

const CreateEditViewPurInv = ({
  isClone = false,
  orderDetail = [],
  vendorDetails = [],
  disabled = false,
  type = "",
  page = "",
  data,
  setOrderDetail,
  setLoading,
  pageName,
  payto,
  shipto,
  pageType,
  clickedplus,
  transfer=false,
}) => {
  const [heading, setHeading] = useState([]);
  const [csvTemLoading, setCsvLoading] = useState(false);
  const formValuesRef = useRef(null); // Store latest form values persistently
  const [storeId, setStoreId] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const isDispatchingRef = useRef(false);
  const submitScheduledRef = useRef(false);
  const [binLocationList, setBinLocationList] = useState([]);
  const rowData = useSelector((state) => state.invoiceRowReducer);
  const searchRef = useRef(null);
  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  const [tcsTdsAmount, setTcsTdsAmount] = useState("");
  const [reload, setReload] = useState(false);
  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [creditNotesOpen, setCreditNotesOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [grnCsvImportOpen, setGrnCsvImportOpen] = useState(false);

  useEffect(() => {
    const updateHeight = () => {
      const firstDivHeight = document.querySelector(".first-div")?.clientHeight;
      setHeightOfFirstDiv(firstDivHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);
  const initialData = {
    sl_no: 1,
    item_name: "",
    item_generic_name: "",
    item_code: "",
    item_hsn: "",
    item_mfg_by: "",
    item_uom: "",
    item_batches: "",
    // item_unit_price: 0,
    item_invoice_open_quantity: 0,
    quantity: 0,
    item_pack_size: 0,
    item_free_quantity: 0,
    item_discount_amount: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    item_gst: 0,
    item_sgst: 0,
    item_igst:0,
    item_cgst: 0,
    pot_id: null,
    item_uom_id: "",
    base_ref_id: null,
    base_ref_type: null,
    base_ref_line_id: null,
    base_ref_doc_number: null,
  };
  const initialFormValues =
    rowData?.data?.length >= 1
      ? {
          ...rowData,
          store_id: storeId,
          data: [...rowData.data, initialData],
        }
      : {
          cmr_code: vendorDetails?.[0]?.cmr_id
            ? {
                label: vendorDetails?.[0]?.cmr_code ?? "",
                value: vendorDetails?.[0]?.cmr_id ?? "",
              }
            : "",
          cmr_name: vendorDetails?.[0]?.cmr_id
            ? {
                label: vendorDetails?.[0]?.cmr_name,
                value: vendorDetails?.[0]?.cmr_id,
              }
            : "",
          cmr_id: vendorDetails?.[0]?.cmr_id,
          store_id: vendorDetails?.[0]?.store_id || storeId || "",
          remarks: vendorDetails?.[0]?.remarks ?? "",
          cmr_balance: vendorDetails?.[0]?.cmr_balance || 0,
          is_inter_state:vendorDetails?.[0]?.gst_type === "Inter"?true:vendorDetails?.[0]?.gst_type === "Intra"?false:null,
          poit_total_discount:
            type === "goods"
              ? orderDetail.reduce(
                  (sum, item) =>
                    sum + (parseFloat(item.item_discount_amount) || 0),
                  0
                )
              : vendorDetails?.[0]?.poit_total_discount,

          ...(vendorDetails?.[0]?.poit_id
            ? { poit_id: vendorDetails?.[0]?.poit_id }
            : { poit_id: "" }),
          poit_order_date: vendorDetails?.[0]?.update_date && !isClone
            ? moment(vendorDetails?.[0]?.update_date).format("YYYY-MM-DD")
            : moment(new Date()).format("YYYY-MM-DD"),
          poit_document_date: vendorDetails?.[0]?.poit_document_date && !isClone
            ? moment(vendorDetails?.[0]?.poit_document_date).format(
                "YYYY-MM-DD"
              )
            : moment(new Date()).format("YYYY-MM-DD"),
          poit_delivery_date: vendorDetails?.[0]?.poit_delivery_date && !isClone
            ? moment(vendorDetails?.[0]?.poit_delivery_date).format(
                "YYYY-MM-DD"
              )
            : moment(new Date()).format("YYYY-MM-DD"),
          poit_reference_inv_date: vendorDetails?.[0]?.poit_reference_inv_date && !isClone
            ? moment(vendorDetails?.[0]?.poit_reference_inv_date).format(
                "YYYY-MM-DD"
              )
            : moment(new Date()).format("YYYY-MM-DD"),
          cmr_gstin: vendorDetails?.[0]?.cmr_gstin ?? "",
          poit_order_status: vendorDetails?.[0]?.poit_order_status ?? "",
          poit_round_off_value: vendorDetails?.[0]?.poit_round_off_value ?? 0,
          cmr_tcs: "",
          cmr_tds: "",
          poit_tcs_or_tds_percentage_id:
            vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
          poit_tcs_or_tds_percentage:
            vendorDetails?.[0]?.tcs_or_tds_percentage || 0,
          poit_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
          poit_tcs_or_tds_amount:
            vendorDetails?.[0]?.poit_tcs_or_tds_amount ||
            vendorDetails?.[0]?.tcs_or_tds_amount ||
            0,
          poit_sub_total: vendorDetails?.[0]?.poit_sub_total || 0,
          poit_total_amount: vendorDetails?.[0]?.poit_total_amount || 0,
          poit_total_gst: vendorDetails?.[0]?.poit_total_gst || 0,
          poit_is_invoice_dis_percentage:
            vendorDetails?.[0]?.poit_is_invoice_dis_percentage ?? true,
          poit_invoice_discount: vendorDetails?.[0]?.poit_invoice_discount ?? 0,
          poit_invoice_discount_percentage:
            vendorDetails?.[0]?.poit_invoice_discount_percentage ?? 0,
          poit_pay_to_address: payto, //new
          poit_ship_to_address: shipto, //new
          header_dis_per: "",
          header_inv_dis_per: vendorDetails?.[0]?.poit_is_invoice_dis_percentage
            ? vendorDetails?.[0]?.poit_invoice_discount_percentage
            : vendorDetails?.[0]?.poit_invoice_discount,
          customer_invoice_number:
            vendorDetails?.[0]?.customer_invoice_number ?? null,
          poit_custom_invoice_number:
            vendorDetails?.[0]?.poit_custom_invoice_number ?? null,
          is_local_purchase: vendorDetails?.[0]?.is_local_purchase,
          on_behalf_of_name: vendorDetails?.[0]?.on_behalf_of_name,
          on_behalf_of_id: vendorDetails?.[0]?.on_behalf_of_id,
          data: [
            ...orderDetail?.map((item, index) => ({
              sl_no: index + 1,
              item_name: item?.item_name,
              item_generic_name: item?.item_generic_name,
              item_code: item?.item_code,
              item_hsn: item?.item_hsn,
              item_manufacturer_name: item?.item_manufacturer_name,
              item_uom: item?.item_uom,
              item_batches:
                type === "purchase"
                  ? []
                  : item?.itemBatchData?.map((batch) => ({
                      item_batch_number: batch?.item_batch_number,
                      item_sellable_quantity: parseFloat(
                        batch?.item_sellable_quantity
                      ),
                      gst_type:vendorDetails?.[0]?.gst_type,
                      item_batch_free_quantity:
                        parseFloat(batch?.item_batch_free_quantity) || 0,

                      item_batch_total_effective_qauntity:
                        parseInt(batch?.item_batch_total_effective_qauntity) ||
                        0, //new

                      item_batch_purchase_rate:
                        parseFloat(batch?.item_batch_purchase_rate) || 0,
                      item_batch_total_base_purchase_rate:
                        parseFloat(
                          batch?.item_batch_total_base_purchase_rate
                        ) || 0, //new

                      item_batch_for_qauntity:
                        parseInt(batch?.item_batch_for_qauntity) || 0, //new
                      item_batch_for_free_qauntity:
                        parseInt(batch?.item_batch_for_free_qauntity) || 0, //new
                      item_batch_scheme_discount_percentage:
                        parseFloat(
                          batch?.item_batch_scheme_discount_percentage
                        ) || 0, //new
                      item_batch_scheme_discount_amount:
                        parseFloat(batch?.item_batch_scheme_discount_amount) ||
                        0, //new
                      item_batch_ptr_amount:
                        parseFloat(batch?.item_batch_ptr_amount) || 0,
                      item_batch_pts:
                        parseFloat(batch?.item_batch_pts_amount) || 0,
                      item_batch_scheme_purchase_rate:
                        parseFloat(batch?.item_batch_scheme_purchase_rate) || 0, //new

                      item_batch_discount_percentage:
                        parseFloat(batch?.item_batch_discount_percentage) || 0, //new
                      item_batch_gen_discount_amount:
                        parseFloat(batch?.item_batch_gen_discount_amount) || 0, //new
                      item_batch_discounted_purchase_rate:
                        parseFloat(
                          batch?.item_batch_discounted_purchase_rate
                        ) || 0, //new

                      item_batch_discount_amount: parseFloat(
                        batch?.item_batch_discount_amount
                      ),
                      item_batch_tax_percentage: parseFloat(
                        batch?.item_batch_tax_percentage
                      ),
                      item_batch_tax_amount: parseFloat(
                        batch?.item_batch_tax_amount
                      ),
                      item_batch_final_purchase_rate: parseFloat(
                        batch?.item_batch_final_purchase_rate
                      ),
                      item_batch_total_purchase_rate: parseFloat(
                        batch?.item_batch_total_purchase_rate
                      ),
                      item_batch_margin_percentage:
                        parseFloat(batch?.item_batch_margin_percentage) || 0,

                      item_batch_unit_price:
                        parseFloat(batch?.item_batch_unit_price) || 0,
                      item_exp_date: batch?.item_exp_date,
                      item_id: batch?.item_id,
                      from_bin_location: batch?.from_bin_location,
                      to_bin_location: batch?.to_bin_location,
                      from_bin_id: batch?.from_bin_id,
                      to_bin_id: batch?.to_bin_id,
                      item_batch_cgst_percentage:batch?.item_batch_cgst_percentage,
                      item_batch_sgst_percentage:batch?.item_batch_sgst_percentage,
                      item_batch_igst_percentage:batch?.item_batch_igst_percentage,
                      item_batch_cgst_amount:batch?.item_batch_cgst_amount,
                      item_batch_sgst_amount:batch?.item_batch_sgst_amount,
                      item_batch_igst_amount:batch?.item_batch_igst_amount,
                    })) || [],
              // item_unit_price: item?.item_unit_price || 0,
              item_return_open_quantity: item?.item_to_be_received || 0,
              quantity: type === "purchase" ? 0 : item?.item_quantity,
              item_pack_size: item?.item_pack_size || 0,
              base_quantity: item?.base_quantity || 0,

              item_free_quantity: parseFloat(item?.item_free_quantity) || 0,
              item_discount_amount:
                type === "purchase" ? 0 : item?.item_discount_amount || 0,
              item_tax_amount:
                type === "purchase" ? 0 : item?.item_tax_amount || 0,
              item_total_amount:
                type === "purchase" ? 0 : item?.item_total_amount || 0,
              item_id: item?.item_id,
              pot_id: item?.pot_id || null,
              gort_id: item?.gort_id || null,
              base_ref_id: item?.gort_id ?? item?.pot_id ?? null,
              base_ref_type: item?.ref_type ?? null,
              base_ref_line_id: item?.item_id ?? null,
              base_ref_doc_number: item?.ref_doc_number ?? null,
              item_gst: parseFloat(item?.item_gst),
              item_sgst: parseFloat(item?.item_sgst||0),
              item_cgst: parseFloat(item?.item_cgst||0),
              item_igst: parseFloat(item?.item_igst||0),
              item_uom_id: item?.item_uom_id,
              item_manufacturer_id: item?.item_manufacturer_id || "",
              uom_dropdown: item?.uom_dropdown
                ? item?.uom_dropdown.map((uom) => ({
                    item_uom_id: uom?.item_id,
                    label: uom?.alt_uom,
                    value: uom?.alt_uom,
                    base_quantity: uom?.base_quantity ?? 1,
                  }))
                : [],
            })),
            // ...(type === "purchase" || type === "invoice"
            //   ? [{ ...initialData }]
            //   : []),
            initialData,
          ],
          vendorTemplate: [],
          creditNoteData: (data?.creditNoteData || []).map((note) => ({
            invoice_number: note?.invoice_number ?? "",
            invoice_total_amount: parseFloat(note?.invoice_total_amount) || 0,
            remaining_amount: parseFloat(note?.remaining_amount) || 0,
            adjusted_amount: parseFloat(note?.adjusted_amount) || 0,
            claimed_amount: parseFloat(note?.claimed_amount) || 0,
            invoice_date: note?.invoice_date ?? "",
            remarks: note?.remarks ?? "",
          })),
          claimed_adjusted: vendorDetails?.[0]?.claimed_adjusted ?? "0.00",
          ledger_closing: vendorDetails?.[0]?.ledger_closing ?? "0.00",
          pcn_net_balance: vendorDetails?.[0]?.pcn_net_balance ?? "0.00",
          pcns_total: vendorDetails?.[0]?.pcns_total ?? "0.00",
          remaining_balance: vendorDetails?.[0]?.remaining_balance ?? "0.00",
        };

  const [initialValue, setInitialValue] = useState(initialFormValues);

  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code is required"),
    cmr_name: Yup.object().required("Customer name is required"),
    data: Yup.array().of(
      Yup.object().shape({
        item_batches: Yup.array().of(
          Yup.object().shape({
            item_batch_purchase_rate: Yup.number()
              .typeError("Must be a number")
              .required("Purchase rate is required")
              .moreThan(0, "Purchase rate must be greater than 0"),

            item_batch_unit_price: Yup.number()
              .typeError("Must be a number")
              .required("MRP is required")
              .moreThan(0, "MRP must be greater than 0")
              .test(
                "MRP-greater-than-final-purchase-rate",
                "MRP must be greater than the final purchase rate",
                function (value) {
                  const { item_batch_final_purchase_rate } = this?.parent;
                  return value > item_batch_final_purchase_rate;
                }
              ),

            item_sellable_quantity: Yup.number()
              .typeError("Must be a number")
              // .integer("Quantity must be an integer")
              .required("Sellable quantity is required")
              .moreThan(0, "Sellable quantity must be greater than 0"),
            item_batch_free_quantity: Yup.number()
              .transform((value) =>
                typeof value === "string" ? parseFloat(value) : value
              ) // Transform string to number
              .typeError("Must be a number"),
              // .integer("Quantity must be an integer")
            item_batch_number: Yup.string().required(
              "Batch number is required"
            ),
            // to_bin_id: Yup.string().required("Bin ID is required"),
            item_exp_date: Yup.date().required("Expiration date is required"),
          })
        ),
      })
    ),
    on_behalf_of_name: Yup.string().when("is_local_purchase", {
      is: true, // when true, it must be filled
      then: (schema) => schema.required("On behalf of name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    dispatch(binLocationListAction(onSuccessBin, onerrorBin));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const PurInvdata = parsed.find((obj) => obj?.purchase_invoice_create);
      if (PurInvdata?.purchase_invoice_create) {
        setHeading(PurInvdata.purchase_invoice_create);
      }
    }
  }, []);

  const onSuccessBin = (data) => {
    setBinLocationList(
      data?.data?.map((item) => ({
        label: (
          <span
            className={`${
              item?.is_expired_bin_location ||
              item?.is_non_sellable_bin_location
                ? "text-F51D00"
                : ""
            }`}
          >
            {item?.bin_location_no}
            {item?.is_expired_bin_location}
            {item?.is_non_sellable_bin_location}
          </span>
        ),
        value: item?.bin_no_id,
        actualLabel: item?.bin_location_no,
      }))
    );
  };
  const onerrorBin = () => {};

  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    const storeData=data?.data;
    const storeState=storeData?.store_state;
    const store_state=storeState?.toLowerCase()?.trim();
    if(store_state===null || store_state===undefined || store_state?.trim()===""){
        errorToast("Please configure store state in store deatils")
        return;
    }
  };
  const onErrorStoreDetails = () => {};
  const handleBilling = (values) => {
    // Block duplicate submissions while a request is already in flight.
    if (isDispatchingRef.current) return;
    let actionType = purchaseInvoiceReceiptCreateAction;
    if (page === "edit") {
      actionType = purchaseInvoiceEditAction;
    }
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.poit_order_status !== "draft"
    ) {
      isDispatchingRef.current = true;
      setButtonLoading(true);
      dispatch(
        purchaseInvoiceEditAction(
          {
            poit_id: values?.poit_id,
            only_remarks: true,
            remarks: values?.remarks,
            is_draft_order: values.submittedButton === "draft" ? true : false,
          },
          (data) => {
            onSuccessOrder(data, values);
          },
          onErrorOrder
        )
      );
    } else {
      if (
        values.data
          ?.slice(0, -1)
          ?.some((item) => item.item_batches.length === 0) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Please add batches for all items");
      } else if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseFloat(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if(!values?.poit_pay_to_address){
          errorToast("Please verify and save the address");
          return;
        }
        if(!values?.poit_ship_to_address){
          errorToast("Please verify and save the address");
          return;
        }
        if (values?.data?.length > 1 || type === "goods") {
          isDispatchingRef.current = true;
          setButtonLoading(true);
          dispatch(
            actionType(
              {
                orderData: {
                  is_draft_order:
                    values.submittedButton === "draft" ? true : false,
                  store_id: values?.store_id,
                  ...(values?.poit_id ? { poit_id: values?.poit_id } : {}),
                  poit_total_gst: Number(values?.poit_total_gst) || 0,
                  poit_total_discount: Number(values?.poit_total_discount) || 0,
                  poit_custom_invoice_number:values?.poit_custom_invoice_number || "",
                  poit_payment_status: "paid",
                  poit_transaction_id: "",
                  poit_billing_address: "",
                  poit_sub_total: Number(values?.poit_sub_total) || 0,
                  poit_total_amount: Number(values?.poit_total_amount) || 0,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  poit_order_date: values?.poit_order_date,
                  poit_document_date: values?.poit_document_date,
                  poit_delivery_date: values?.poit_delivery_date,
                  poit_reference_inv_date: values?.poit_reference_inv_date || null,
                  cmr_gstin: values?.cmr_gstin || null,
                  poit_round_off_value: Number(values?.poit_round_off_value) || 0,
                  poit_tcs_or_tds_percentage_id:
                    values?.poit_tcs_or_tds_percentage_id ?? "",
                  poit_tcs_or_tds_percentage:
                    values?.poit_tcs_or_tds_percentage || 0,
                  poit_tds_tcs_type: values?.poit_tds_tcs_type ?? "",
                  poit_tcs_or_tds_amount: values?.poit_tcs_or_tds_amount || 0,
                  only_remarks: false,
                  poit_is_invoice_dis_percentage:
                    values?.poit_is_invoice_dis_percentage,
                  poit_invoice_discount: values?.poit_invoice_discount,
                  poit_invoice_discount_percentage:
                    values?.poit_invoice_discount_percentage,
                  customer_invoice_number:
                    values?.customer_invoice_number ?? null,
                  poit_pay_to_address: values?.poit_pay_to_address || null, //new
                  poit_ship_to_address: values?.poit_ship_to_address || null, //new
                  is_local_purchase: values?.is_local_purchase, //new
                  on_behalf_of_name: values?.on_behalf_of_name, //new
                  on_behalf_of_id: values?.on_behalf_of_id, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter"
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  ...(values?.poit_id ? { poit_id: values?.poit_id } : {}),
                  item_id: item?.item_id,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_uom: item?.item_uom,
                  item_quantity: parseFloat(item?.quantity),
                  item_pack_size: parseFloat(item.item_pack_size),
                  item_free_quantity: item?.item_batches?.reduce(
                    (sum, batch) =>
                      sum + (parseFloat(batch.item_batch_free_quantity) || 0),
                    0
                  ),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_discount_amount: item?.item_discount_amount || 0,
                  item_tax_amount: item?.item_tax_amount || 0,
                  item_gst: item?.item_gst || 0,
                  item_cgst: values?.is_inter_state===false?(item?.item_cgst):0,
                  item_sgst: values?.is_inter_state===false?(item?.item_sgst):0,
                  item_igst: values?.is_inter_state===true?(item?.item_igst):0,
                  ...(item?.pot_id
                    ? { pot_id: item?.pot_id }
                    : { pot_id: null }),
                  ...(item?.gort_id
                    ? { gort_id: item?.gort_id }
                    : { gort_id: null }),
                  base_ref_id: item?.base_ref_id ?? null,
                  base_ref_type: item?.base_ref_type ?? null,
                  base_ref_line_id: item?.base_ref_line_id ?? null,
                  base_ref_doc_number: item?.base_ref_doc_number ?? null,
                  item_uom_id: item?.item_uom_id ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    ...(values?.poit_id ? { poit_id: values?.poit_id } : {}),
                    item_sellable_quantity:
                      parseFloat(batch?.item_sellable_quantity) || 0,
                    item_batch_free_quantity:
                      parseFloat(batch?.item_batch_free_quantity) || 0,

                    item_batch_total_effective_qauntity:
                      parseInt(batch?.item_batch_total_effective_qauntity) || 0, //new
                    item_batch_purchase_rate: Number(batch?.item_batch_purchase_rate) || 0,

                    item_batch_total_base_purchase_rate:
                      parseFloat(batch?.item_batch_total_base_purchase_rate) ||
                      0, //new

                    item_batch_for_qauntity:
                      parseInt(batch?.item_batch_for_qauntity) || 0, //new
                    item_batch_for_free_qauntity:
                      parseInt(batch?.item_batch_for_free_qauntity) || 0, //new
                    item_batch_scheme_discount_percentage:
                      parseFloat(
                        batch?.item_batch_scheme_discount_percentage
                      ) || 0, //new
                    item_batch_scheme_discount_amount:
                      parseFloat(batch?.item_batch_scheme_discount_amount) || 0, //new

                    item_batch_scheme_purchase_rate:
                      parseFloat(batch?.item_batch_scheme_purchase_rate) || 0, //new

                    item_batch_discount_percentage:
                      parseFloat(batch?.item_batch_discount_percentage) || 0, //new
                    item_batch_gen_discount_amount:
                      parseFloat(batch?.item_batch_gen_discount_amount) || 0, //new
                    item_batch_discounted_purchase_rate:
                      parseFloat(batch?.item_batch_discounted_purchase_rate) ||
                      0, //new
                    item_batch_margin_percentage:
                      parseFloat(batch?.item_batch_margin_percentage) || 0,
                    item_batch_discount_amount:
                      Number(batch?.item_batch_discount_amount) || 0,
                    item_batch_tax_percentage: Number(batch?.item_batch_tax_percentage) || 0,
                    item_batch_tax_amount: Number(batch?.item_batch_tax_amount) || 0,
                    item_batch_final_purchase_rate:
                      Number(batch?.item_batch_final_purchase_rate) || 0,
                    item_batch_total_purchase_rate:
                      Number(batch?.item_batch_total_purchase_rate) || 0,
                    item_batch_unit_price: Number(batch?.item_batch_unit_price) || 0,
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    // from_bin_location: batch?.from_bin_location,
                    to_bin_location: batch?.to_bin_location,
                    // from_bin_id: batch?.from_bin_id,
                    to_bin_id: batch?.to_bin_id,
                    item_batch_cgst_percentage:values?.is_inter_state===false?(batch?.item_batch_cgst_percentage||0):0,
                    item_batch_sgst_percentage:values?.is_inter_state===false?(batch?.item_batch_sgst_percentage||0):0,
                    item_batch_igst_percentage:values?.is_inter_state===true?(batch?.item_batch_igst_percentage||0):0,
                    item_batch_cgst_amount:values?.is_inter_state===false?(batch?.item_batch_cgst_amount||0):0,
                    item_batch_sgst_amount:values?.is_inter_state===false?(batch?.item_batch_sgst_amount||0):0,
                    item_batch_igst_amount:values?.is_inter_state===true?(batch?.item_batch_igst_amount||0):0,
                    item_batch_ptr_amount:
                      parseFloat(batch?.item_batch_ptr_amount) || 0,
                    item_batch_pts_amount:
                      parseFloat(batch?.item_batch_pts) || 0,
                  })),
                creditNoteData: (values?.creditNoteData || [])
                  .filter((note) => note?.isChecked)
                  .map((note) => ({
                    invoice_number: note?.invoice_number ?? "",
                    invoice_total_amount:
                      parseFloat(note?.invoice_total_amount) || 0,
                    remaining_amount: parseFloat(note?.remaining_amount) || 0,
                    adjusted_amount: parseFloat(note?.adjusted_amount) || 0,
                    claimed_amount: parseFloat(note?.claimed_amount) || 0,
                    invoice_date: note?.invoice_date ?? "",
                    remarks: note?.remarks ?? "",
                  })),
              },
              (data) => {
                onSuccessOrder(data, values);
              },
              onErrorOrder
            )
          );
        }
      }
    }
  };

  const onSuccessOrder = (data, values) => {
    formValuesRef.current = null; // Reset after handling
    isDispatchingRef.current = false;
    setButtonLoading(false);
    if (values?.save !== "auto") {
      navigate("/purchase-invoice");
    }
    if (values?.submittedButton === "print") {
      const poitId =
        data?.data?.orderData?.poit_id ??
        data?.data?.orderData?.[0]?.poit_id;
      if (poitId) {
        handlea4Print(poitId, "purchase_invoice", dispatch);
      }
    }
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      remarks: "",
      poit_total_discount: 0,
      poit_order_date: null,
      poit_document_date: null,
      poit_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = (data) => {
    isDispatchingRef.current = false;
    setButtonLoading(false);

    errorToast(data?.data?.message);
  };

  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  const handleFileUpload = (event, values) => {
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = null; // This resets the file input
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const parsedData = results.data;
        if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
          errorToast(
            "Error: The CSV file is empty or contains no valid records."
          );
          return; // Stop further processing
        }
        setCsvLoading(true);
        dispatch(
          goodsTempProVeriAction(
            {
              cmr_id: values?.cmr_id,
              cmr_vendor_name: values?.cmr_name?.label,
              itemData: parsedData,
            },
            onSuccess,
            onError
          )
        );
      },
      error: (error) => {
        errorToast("Error parsing file:", error);
      },
    });
  };

  const onSuccess = (data) => {
    navigate("/goods-receipt-csv", {
      state: { data: data.data, type: "purchase_invoice" },
    });

    setCsvLoading(false);
  };
  const onError = (data) => {
    setCsvLoading(false);
    errorToast(data?.data?.message);
  };

  const autoDraft = (values) => {
    if (isDispatchingRef.current) return;
    let actionType = purchaseInvoiceReceiptCreateAction;
    if (page === "edit") {
      actionType = purchaseInvoiceEditAction;
    }
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.poit_order_status !== "draft"
    ) {
      isDispatchingRef.current = true;
      setButtonLoading(true);
      dispatch(
        purchaseInvoiceEditAction(
          {
            poit_id: values?.poit_id,
            only_remarks: true,
            remarks: values?.remarks,
            is_draft_order: true,
          },
          (data) => {
            onSuccessOrder(data, values);
          },
          onErrorOrder
        )
      );
    } else {
      if (
        values.data
          ?.slice(0, -1)
          ?.some((item) => item.item_batches.length === 0) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Please add batches for all items");
      } else if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseFloat(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if (values?.data?.length > 1 || type === "goods") {
          isDispatchingRef.current = true;
          setButtonLoading(true);
          dispatch(
            actionType(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: values?.store_id,
                  ...(values?.poit_id ? { poit_id: values?.poit_id } : {}),
                  poit_total_gst: Number(values?.poit_total_gst) || 0,
                  poit_total_discount: Number(values?.poit_total_discount) || 0,
                  poit_payment_status: "paid",
                  poit_transaction_id: "",
                  poit_billing_address: "",
                  poit_sub_total: Number(values?.poit_sub_total) || 0,
                  poit_total_amount: Number(values?.poit_total_amount) || 0,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  poit_order_date: values?.poit_order_date,
                  poit_custom_invoice_number:values?.poit_custom_invoice_number||"",
                  poit_document_date: values?.poit_document_date,
                  poit_delivery_date: values?.poit_delivery_date,
                  poit_reference_inv_date: values?.poit_reference_inv_date || null,
                  cmr_gstin: values?.cmr_gstin || null,
                  poit_round_off_value: Number(values?.poit_round_off_value) || 0,
                  poit_tcs_or_tds_percentage_id:
                    values?.poit_tcs_or_tds_percentage_id ?? "",
                  poit_tcs_or_tds_percentage:
                    values?.poit_tcs_or_tds_percentage || 0,
                  poit_tds_tcs_type: values?.poit_tds_tcs_type ?? "",
                  poit_tcs_or_tds_amount: values?.poit_tcs_or_tds_amount || 0,
                  only_remarks: false,
                  poit_is_invoice_dis_percentage:
                    values?.poit_is_invoice_dis_percentage,
                  poit_invoice_discount: values?.poit_invoice_discount,
                  poit_invoice_discount_percentage:
                    values?.poit_invoice_discount_percentage,
                  customer_invoice_number:
                    values?.customer_invoice_number ?? null,
                  poit_pay_to_address: values?.poit_pay_to_address || null, //new
                  poit_ship_to_address: values?.poit_ship_to_address || null, //new
                  is_local_purchase: values?.is_local_purchase, //new
                  on_behalf_of_name: values?.on_behalf_of_name, //new
                  on_behalf_of_id: values?.on_behalf_of_id, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter"
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_id: item?.item_id,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_uom: item?.item_uom,
                  item_quantity: parseFloat(item?.quantity),
                  item_pack_size: parseFloat(item.item_pack_size),
                  item_free_quantity: item?.item_batches?.reduce(
                    (sum, batch) =>
                      sum + (parseFloat(batch.item_batch_free_quantity) || 0),
                    0
                  ),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_discount_amount: item?.item_discount_amount || 0,
                  item_tax_amount: item?.item_tax_amount || 0,
                  item_gst: item?.item_gst || 0,
                  item_cgst: values?.is_inter_state===false?(item?.item_cgst):0,
                  item_sgst: values?.is_inter_state===false?(item?.item_sgst):0,
                  item_igst: values?.is_inter_state===true?(item?.item_igst):0,
                  ...(item?.pot_id
                    ? { pot_id: item?.pot_id }
                    : { pot_id: null }),
                  ...(item?.gort_id
                    ? { gort_id: item?.gort_id }
                    : { gort_id: null }),
                  base_ref_id: item?.base_ref_id ?? null,
                  base_ref_type: item?.base_ref_type ?? null,
                  base_ref_line_id: item?.base_ref_line_id ?? null,
                  base_ref_doc_number: item?.base_ref_doc_number ?? null,
                  item_uom_id: item?.item_uom_id ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_sellable_quantity:
                      parseFloat(batch?.item_sellable_quantity) || 0,
                    item_batch_free_quantity:
                      parseFloat(batch?.item_batch_free_quantity) || 0,

                    item_batch_total_effective_qauntity:
                      parseInt(batch?.item_batch_total_effective_qauntity) || 0, //new
                    item_batch_purchase_rate: Number(batch?.item_batch_purchase_rate) || 0,

                    item_batch_total_base_purchase_rate:
                      parseFloat(batch?.item_batch_total_base_purchase_rate) ||
                      0, //new

                    item_batch_for_qauntity:
                      parseInt(batch?.item_batch_for_qauntity) || 0, //new
                    item_batch_for_free_qauntity:
                      parseInt(batch?.item_batch_for_free_qauntity) || 0, //new
                    item_batch_scheme_discount_percentage:
                      parseFloat(
                        batch?.item_batch_scheme_discount_percentage
                      ) || 0, //new
                    item_batch_scheme_discount_amount:
                      parseFloat(batch?.item_batch_scheme_discount_amount) || 0, //new

                    item_batch_scheme_purchase_rate:
                      parseFloat(batch?.item_batch_scheme_purchase_rate) || 0, //new

                    item_batch_discount_percentage:
                      parseFloat(batch?.item_batch_discount_percentage) || 0, //new
                    item_batch_gen_discount_amount:
                      parseFloat(batch?.item_batch_gen_discount_amount) || 0, //new
                    item_batch_discounted_purchase_rate:
                      parseFloat(batch?.item_batch_discounted_purchase_rate) ||
                      0, //new
                    item_batch_margin_percentage:
                      parseFloat(batch?.item_batch_margin_percentage) || 0,
                    item_batch_discount_amount:
                      Number(batch?.item_batch_discount_amount) || 0,
                    item_batch_tax_percentage: Number(batch?.item_batch_tax_percentage) || 0,
                    item_batch_tax_amount: Number(batch?.item_batch_tax_amount) || 0,
                    item_batch_final_purchase_rate:
                      Number(batch?.item_batch_final_purchase_rate) || 0,
                    item_batch_total_purchase_rate:
                      Number(batch?.item_batch_total_purchase_rate) || 0,
                    item_batch_unit_price: Number(batch?.item_batch_unit_price) || 0,
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    // from_bin_location: batch?.from_bin_location,
                    to_bin_location: batch?.to_bin_location,
                    // from_bin_id: batch?.from_bin_id,
                    to_bin_id: batch?.to_bin_id,
                    item_batch_cgst_percentage:values?.is_inter_state===false?(batch?.item_batch_cgst_percentage||0):0,
                    item_batch_sgst_percentage:values?.is_inter_state===false?(batch?.item_batch_sgst_percentage||0):0,
                    item_batch_igst_percentage:values?.is_inter_state===true?(batch?.item_batch_igst_percentage||0):0,
                    item_batch_cgst_amount:values?.is_inter_state===false?(batch?.item_batch_cgst_amount||0):0,
                    item_batch_sgst_amount:values?.is_inter_state===false?(batch?.item_batch_sgst_amount||0):0,
                    item_batch_igst_amount:values?.is_inter_state===true?(batch?.item_batch_igst_amount||0):0,
                    item_batch_ptr_amount:
                    parseFloat(batch?.item_batch_ptr_amount) || 0,
                  item_batch_pts_amount:
                    parseFloat(batch?.item_batch_pts) || 0,
                  })),
                creditNoteData: (values?.creditNoteData || [])
                  .filter((note) => note?.isChecked)
                  .map((note) => ({
                    invoice_number: note?.invoice_number ?? "",
                    invoice_total_amount:
                      parseFloat(note?.invoice_total_amount) || 0,
                    remaining_amount: parseFloat(note?.remaining_amount) || 0,
                    adjusted_amount: parseFloat(note?.adjusted_amount) || 0,
                    claimed_amount: parseFloat(note?.claimed_amount) || 0,
                    invoice_date: note?.invoice_date ?? "",
                    remarks: note?.remarks ?? "",
                  })),
              },
              (data) => {
                successToast(data?.message);
                // setLoading(true);
                setTimeout(() => {
                  // setLoading(false);
                }, 50);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-purchase-invoice/${data?.data?.orderData?.poit_id||data?.data?.orderData?.[0]?.poit_id}?new`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                errorToast(data?.data?.message);
              }
            )
          );
        }
      }
    }
  };

  return (
    <>
      <BulkGrnModal
        prefixName="poit"
        setLoading={setLoading}
        disabled={disabled}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setOrderDetail={setOrderDetail}
      />
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          if (submitScheduledRef.current || isDispatchingRef.current) {
            actions.setSubmitting(false);
            return;
          }
          submitScheduledRef.current = true;
          setButtonLoading(true);
          setTimeout(() => {
            submitScheduledRef.current = false;
            handleBilling(values, actions); // arms isDispatchingRef on dispatch
            if (!isDispatchingRef.current) {
              setButtonLoading(false);
            }
            actions.setSubmitting(false); // Notify Formik that submission is done
          }, 500);
        }}
      >
        {({ values }) => {
          setFormValues(values);
          formValuesRef.current = values; // Store latest values persistently
          return (
            <Form className="h-full">
              <PurchaseBatchesPanel
                open={addbatch}
                disabled={disabled}
                disName="poit_total_discount"
                binLocationList={binLocationList}
                setItemId={setItemId}
                itemId={itemId}
                setOpen={setAddbatch}
                itemValues={values}
                prefix="poit"
              />
              <GrnCsvImport
                prefixName="poit"
                tempalteArray={initUploadDocumentsGrn.map(
                  ({ documentType, expectedHeaders }) => ({
                    documentType,
                    expectedHeaders,
                  })
                )}
                handleFileUpload={(e) => {
                  if (values?.cmr_id) {
                    handleFileUpload(e, values);
                  } else {
                    e.target.value = null; // This resets the file input
                    errorToast("Please select Vendor");
                  }
                }}
                setIsModalOpen={setIsModalOpen}
                isModalOpen={isModalOpen}
                setGrnCsvImportOpen={setGrnCsvImportOpen}
                grnCsvImportOpen={grnCsvImportOpen}
              />
              <PurchaseCreditNotePanel
                page={page}
                open={creditNotesOpen}
                setOpen={setCreditNotesOpen}
              />
              <div
                style={{
                  height: `calc(100% - 8rem)`,
                }}
                className="mx-5 flex flex-col h-full "
              >
                <SalesPurchaseNavbar
                  isClone={isClone}
                  autoDraft={autoDraft}
                  clickedplus={clickedplus}
                  pageType={pageType}
                  pageName={pageName}
                  page={page}
                  transfer={transfer}
                  csvTemLoading={csvTemLoading}
                  csvButtonText="Import CSV"
                  handleFileUpload={(e, type) => {
                    setGrnCsvImportOpen(true);
                  }}
                  importcsv={true}
                  section="purchase"
                  name="poit"
                  disabled={disabled}
                  searchRef={searchRef}
                  tempalteArray={initUploadDocumentsGrn.map(
                    ({ documentType, expectedHeaders }) => ({
                      documentType,
                      expectedHeaders,
                    })
                  )}
                  fetchCreditNoteFn={() => {
                    setCreditNotesOpen(true);
                  }}
                  storeDetails={storeDetails}
                  standAlone={!transfer}
                />
                <PurchaseItemsSection
                  heading={heading}
                  disabled={values.is_inter_state===null || disabled || type === "goods"}
                  prefixName="poit"
                  addBatchFn={(id) => {
                    setAddbatch(true);
                    setItemId(id);
                  }}
                  searchRef={searchRef}
                  initialData={initialData}
                />
              </div>

              <SalesPurchaseFooter
                EditFn={() => {
                  navigate(`/edit-purchase-invoice/${values?.poit_id}`);
                }}
                formValuesRef={formValuesRef}
                transaction="Purchase Invoice"
                transaction_type="purchase_invoice"
                buttonLoading={buttonLoading}
                name="poit_total_discount"
                page={page}
                disabled={disabled}
                prefixName="poit"
                tcsTdsAmount={tcsTdsAmount}
                setTcsTdsAmount={setTcsTdsAmount}
                handleBilling={handleBilling}
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewPurInv;

export const initUploadDocumentsGrn = [
  {
    index: 0,
    documentType: "Order-Data",
    filename: "",
    expectedHeaders: [
      "cmr_id",
      "cmr_code",
      "cmr_name",
      "poit_order_date",
      "poit_document_date",
      "poit_delivery_date",
      "poit_total_gst",
      "poit_total_discount",
      "poit_total_amount",
      "remarks",
      "poit_sub_total",
    ],
  },
  {
    index: 1,
    documentType: "Item-Data",
    filename: "",
    expectedHeaders: ["item_code", "item_name", "item_hsn", "item_uom"],
  },
  {
    index: 2,
    documentType: "Batch-Data",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_batch_number",
      "item_exp_date",
      "item_batch_purchase_rate",
      "item_batch_total_base_purchase_rate",
      "item_sellable_quantity",
      "item_batch_free_quantity",
      "item_batch_total_effective_qauntity",
      "item_batch_for_qauntity",
      "item_batch_for_free_qauntity",
      "item_batch_scheme_discount_percentage",
      "item_batch_scheme_discount_amount",
      "item_batch_scheme_purchase_rate",
      "item_batch_discount_percentage",
      "item_batch_gen_discount_amount",
      "item_batch_discounted_purchase_rate",
      "item_batch_discount_amount",
      "item_batch_tax_percentage",
      "item_batch_tax_amount",
      "item_batch_final_purchase_rate",
      "item_batch_unit_price",
      "item_batch_margin_percentage",
      "item_batch_total_purchase_rate",
      "item_uom",
      "to_bin_location",
      "to_bin_id",
    ],
  },
];
